// extracted by mini-css-extract-plugin
export default {"root":"LabelEditor_root__0Qdth","edit":"LabelEditor_edit__Iibao","input":"LabelEditor_input__CF-VD"};